export default "__VITE_ASSET__f31bbdb6__"